module.exports = __webpack_public_path__ + "static/cloud-sprinkles-c9b61a1f9a95e38b0d23477ab783d696.webp";